import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ThemeProps, RTLProps } from "@/shared/prop-types/ReducerProps";
import CheckboxField from "@/shared/components/form/CheckboxField";
import {
  Modal,
  ModalBody, Row, Col, ButtonToolbar, Button, ModalHeader
} from "reactstrap";
import { Form } from "react-final-form";
import formValidation from "@/shared/validation/program-engagement";
import axios from "axios";
import {Table} from 'antd';
import { flashError, sendFlashMessage } from "@/shared/components/flash";
import { getProgramAction } from "@/redux/actions/programActions";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TooltipPopup from '@/shared/components/form/TooltipPopup';
import { BUDGET_INFO_POPUP_DATA } from './BudgetCascadingPopupData';
import RadioButtonField from '@/shared/components/form/RadioButton';
import { makeFormData } from './common'
import HierarchyThresholdModal from './HierarchyThresholdModal';
import HierarchySaveModal from './HierarchySaveModal';
import { flattenHierarchy } from './flattenHierarchy';

const EngagementModal = ({
  dispatch,
  data,
  isOpen,
  toggle,
  theme,
  rtl,
}) => {
  const [loading, setLoading] = useState(false);
  const [openTooltipPopup, setTooltipPopup] = useState(null);
  const [isOpenHierarchy, setOpenHierarchy] = useState(false);
  const [isOpenHierarchyList, setOpenHierarchyList] = useState(false);
  const [isOpenHierarchyResult, setOpenHierarchyResult] = useState(false);
  const [formValues, setFormValues] = useState([]);
  const [hierarchyListData, setHierarchyListData] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [hierarchyListDataResult, setHierarchyListDataResult] = useState([]);
  const [showCascadingThreshold, setShowCascadingThreshold] = useState(data?.use_cascading_approvals || false);
  const [isCascadeConfirmOpen, setCascadeConfirmOpen] = useState(false);
  const [activeCascadeField, setActiveCascadeField] = useState(null);

  // ICOV3-1572: fires immediately on an eligible field's own change, not on
  // Save — see ~/.claude-specs/ICOV3_React/ICOV3-1572-specs.md Step 13.
  const handleCascadeFieldChange = (fieldName, newValue) => {
    data[fieldName] = newValue;
    setActiveCascadeField({ name: fieldName, value: newValue });
    setCascadeConfirmOpen(true);
  };
  const handleCloseTooltipPopup = () => {
    setTooltipPopup(null);
};
    const [showHierarchyThresholdModal, setShowHierarchyThresholdModal] = useState(false);

const handleOpenTooltipPopup = (title) => {
    setTooltipPopup(title);
};

const [isCascadingEnabled, setIsCascadingEnabled] = useState(
  data?.use_cascading_approvals || false
);

useEffect(() => {
  if (
    data.program_managers_can_invite_participants &&
    data.allow_award_new_participant
  ) {
    data.manager_invite = "invite_award";
  } else if (data.program_managers_can_invite_participants) {
    data.manager_invite = "invite";
  } else {
    data.manager_invite = "hide";
  }
}, [data]);

useEffect(() => {
  setIsCascadingEnabled(!!data?.use_cascading_approvals);
}, [data]);

  const performSave = async (saveData) => {
    setLoading(true);
    try {
      const response = await axios.put(
        `/organization/${saveData.organization_id}/program/${saveData.id}`,
        saveData
      );

      setLoading(false);
      if (response.status === 200) {
        dispatch(
          sendFlashMessage("Program has been updated", "alert-success", "top")
        );
        dispatch(getProgramAction(saveData.organization_id, saveData.id));
      }
    } catch (e) {
      setLoading(false);
      dispatch(
        sendFlashMessage("Program could not be updated", "alert-danger", "top")
      );
      throw new Error(`API error:${e?.message}`);
    }
  };

  const onSubmitForm = (values) => {
    delete data['merchants'];
    performSave(data);
  };
    const toggleHierarchy = (values) => {
        setOpenHierarchy(prevState => !prevState)
    }

    const toggleHierarchyList = () => {
        setOpenHierarchyList(prevState => !prevState)
    }

    const toggleHierarchyResult = () => {
        setOpenHierarchyResult(prevState => !prevState)
    }
 
    const handleManagerInviteChange = () => {
        toggleHierarchy();
    };
      const onSubmitHierarchy = (values) => {
        const programData = makeFormData(data, formValues)
        axios
          .get(`/organization/${data.organization_id}/program/${data.id}/hierarchy-prepare`, programData)
          .then((res) => {
            if (res.status == 200) {
              setHierarchyListData(flattenHierarchy(res.data));
    
              toggleHierarchy();
              const tmpCheckedState = [];
              res.data.map(item => {
                  tmpCheckedState.push({checked: true, value: item.id});
              });
              setCheckedState(tmpCheckedState);
              toggleHierarchyList();
            }
          })
          .catch((err) => {
            flashError(dispatch, err.response.data)
            setLoading(false);
            toggleHierarchy();
          });
      };
         const onSubmitHierarchyList = () => {
            const programData = makeFormData(data, formValues)
            const programIds = [];
            checkedState.map(item => {
              if(item.checked){
                programIds.push(item.value)
              }
            });
            programData.programIds = programIds;
            axios
              .put(`/organization/${data.organization_id}/program/${data.id}/update-hierarchy`, programData)
              .then((res) => {
                if (res.status == 200) {
                  setHierarchyListDataResult(res.data);
                  toggleHierarchyList();
                  toggleHierarchyResult();
                }
              })
              .catch((err) => {
                flashError(dispatch, err.response.data)
                setLoading(false);
                toggleHierarchyList();
              });
          };
        const columnsHierarchyList = [
            {
              title: 'Program ID',
              dataIndex: 'id',
              key: 'id',
              render: (text) => <a>{text}</a>,
            },
            {
              title: 'Program Name',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Copy\\Update?',
              key: 'action',
              render: (_, record, index) => (
                <>
                  <div className="checkbox-custom2">
                    <CheckboxField
                      name={`action-checkbox-${record.id}`}
                      label={ 'update'}
                      checked={checkedState[index].checked}
                      disabled={checkedState[index].value === data.id ? true : false}
                      onChange={(e) => {
                        const tmpCheckedState = [...checkedState];
                        tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
                        setCheckedState(tmpCheckedState)
                      }}
                    />
                  </div>
                </>
              ),
            },
          ];
    const columnsHierarchyResult = [
        {
        title: 'Program ID',
        dataIndex: 'id',
        key: 'id',
        render: (text) => <a>{text}</a>,
        },
        {
        title: 'Program Name',
        dataIndex: 'name',
        key: 'name',
        },
        {
        title: 'Result',
        dataIndex: 'result',
        key: 'result',
        },
    ];

const shouldShowThreshold =
  (!data.parent_id && isCascadingEnabled) ||
  (data.parent_id && !!data.rootProgram?.use_cascading_approvals);

  return (
<>
    <Modal
      className={`modal-program modal-lg ${theme.className} ${rtl.direction}-support`}
      isOpen={isOpen}
      toggle={toggle}
    >
      <Form
        onSubmit={onSubmitForm}
        validate={(values) => formValidation.validateForm(values)}
        initialValues={data}
      >
        {({ handleSubmit, form, submitting, pristine, values }) => (
          <form className="form" onSubmit={handleSubmit}>
            <ModalHeader className="w100">
              <Row className="w100">
                <Col md="6" lg="6" xl="6">
                  <h3>Engagement</h3>
                </Col>
                <Col md="6" lg="6" xl="6" className="text-right">
                  <ButtonToolbar className="modal__footer flex justify-content-right w100">
                    <Button
                      outline
                      color="primary"
                      className="mr-3"
                      onClick={toggle}
                    >
                      Close
                    </Button>{" "}
                    <Button
                      type="submit"
                      disabled={loading}
                      className="btn btn-primary"
                      color="#ffffff"
                    >
                      Save
                    </Button>
                  </ButtonToolbar>
                </Col>
              </Row>
            </ModalHeader>
            <ModalBody className="modal-lg">
              {!data.parent_id && (
                <>
                  <Row>
                    <Col>
                      <h4 className="padding-10">Approvals and Budget: </h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="use_budget_cascading"
                          label="Use budget cascading"
                          checked={data.use_budget_cascading}
                          onChange={() => handleCascadeFieldChange('use_budget_cascading', !data.use_budget_cascading)}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("use_budget_cascading")
                          }
                          title="use_budget_cascading"
                          text={BUDGET_INFO_POPUP_DATA.budgetCascadingInfoTitle}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="4" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="budget_summary"
                          label="Enable budget summary"
                          checked={data.budget_summary}
                          onChange={() => handleCascadeFieldChange('budget_summary', !data.budget_summary)}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("budget_summary")
                          }
                          title="budget_summary"
                          text={BUDGET_INFO_POPUP_DATA.budgetSummaryInfoTitle}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="4" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="use_cascading_approvals"
                          label="Use Cascading Approvals"
                          checked={isCascadingEnabled}
                          onChange={() => {
                            const newValue = !isCascadingEnabled;
                            setIsCascadingEnabled(newValue);
                            handleCascadeFieldChange('use_cascading_approvals', newValue);
                          }}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("use_cascading_approvals")
                          }
                          title="use_cascading_approvals"
                          text={BUDGET_INFO_POPUP_DATA.cascadingApproval}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="enable_schedule_awards"
                          label="Enable Schedule Awards"
                          checked={data.enable_schedule_awards}
                          onChange={() => handleCascadeFieldChange('enable_schedule_awards', !data.enable_schedule_awards)}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("enable_schedule_awards")
                          }
                          title="enable_schedule_awards"
                          text={BUDGET_INFO_POPUP_DATA.scheduleDate}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="schedule_awards_required"
                          label="Schedule Awards Required"
                          checked={data.schedule_awards_required}
                          onChange={() => handleCascadeFieldChange('schedule_awards_required', !data.schedule_awards_required)}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("schedule_awards_required")
                          }
                          title="schedule_awards_required"
                          text={BUDGET_INFO_POPUP_DATA.scheduleDate}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                   {shouldShowThreshold && (
                      <Col md="4" lg="4" xl="4">
                      <label className="form__form-group-label">
                        Minimum Approval Amount Threshold
                      </label>

                      <div className="form__form-group d-flex justify-content-around">
                        <input
                          type="number"
                          className="form-control"
                          name="cascading_approval_min_threshold"
                          defaultValue={data?.cascading_approval_min_threshold ?? ''}
                          onChange={(e) => {
                            data.cascading_approval_min_threshold = e.target.value;
                          }}
                        />

                        <Button
                          color="primary"
                          size="sm"
                          className="ml-2"
                          onClick={() => {
                            setFormValues({
                              cascading_approval_min_threshold:
                                data.cascading_approval_min_threshold,
                            });
                            toggleHierarchy();
                          }}
                        >
                          Save
                        </Button>
                      </div>
                        <span
                            onClick={() => setShowHierarchyThresholdModal(true)}
                            style={{
                            color: '#1976d2',
                            cursor: 'pointer',
                            fontSize: '13px',
                            textDecoration: 'underline',
                            whiteSpace: 'nowrap'
                            }}
                        >
                            Review Hierarchy Thresholds
                        </span>
                    </Col> )}
                  </Row>
                </>
              )}
        {/* SUBPROGRAM THRESHOLD */}
          {data.parent_id &&
            !!data.rootProgram?.use_cascading_approvals && (
              <><Row>
                  <Col>
                      <h4 className="padding-10">Approvals and Budget: </h4>
                        </Col>
                    </Row>
                  <Row>
             
                <Col md="4" lg="4" xl="4">
                  <label className="form__form-group-label">
                    Minimum Approval Amount Threshold
                  </label>

                  <div className="form__form-group d-flex justify-content-around">
                    <input
                      type="number"
                      className="form-control"
                      name="cascading_approval_min_threshold"
                      defaultValue={data?.cascading_approval_min_threshold || ''}
                      onChange={(e) => {
                        data.cascading_approval_min_threshold = e.target.value;
                      }}
                    />

                    <Button
                      color="primary"
                      size="sm"
                      className="ml-2"
                      onClick={() => {
                        setFormValues({
                          cascading_approval_min_threshold:
                            data.cascading_approval_min_threshold,
                        });
                        toggleHierarchy();
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </Col>
                <Col md="4" lg="4" xl="4">
                    <span
                            onClick={() => setShowHierarchyThresholdModal(true)}
                            style={{
                            color: '#1976d2',
                            cursor: 'pointer',
                            fontSize: '13px',
                            textDecoration: 'underline',
                            whiteSpace: 'nowrap'
                            }}
                        >
                            Review Hierarchy Thresholds
                        </span>
                </Col>
            </Row> </> )}
              <Row>
                <Col>
                  <h4 className="padding-10">Social Wall: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_social_wall"
                      label="Enable Social Wall"
                      checked={data?.uses_social_wall}
                      onChange={() => handleCascadeFieldChange('uses_social_wall', !data.uses_social_wall)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_hierarchy_to_view_social_wall"
                      label="Other programs in this hierarchy can view this programs social wall"
                      checked={data?.allow_hierarchy_to_view_social_wall}
                      onChange={() => {
                        data.allow_hierarchy_to_view_social_wall =
                          !data.allow_hierarchy_to_view_social_wall;
                      }}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="can_view_hierarchy_social_wall"
                      label="This program can view other programs social wall"
                      checked={data?.can_view_hierarchy_social_wall}
                      onChange={() => {
                        data.can_view_hierarchy_social_wall =
                          !data.can_view_hierarchy_social_wall;
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="managers_can_post_social_wall_messages"
                      label="Managers can post messages"
                      checked={data?.managers_can_post_social_wall_messages}
                      onChange={() => handleCascadeFieldChange('managers_can_post_social_wall_messages', !data.managers_can_post_social_wall_messages)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="social_wall_separation"
                      label="Allow participants to view the social wall of any program he is not currently logged into"
                      checked={data?.social_wall_separation}
                      onChange={() => handleCascadeFieldChange('social_wall_separation', !data.social_wall_separation)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="remove_social_from_pending_deactivation"
                      label="Remove Social From Pending Deactivation View"
                      checked={data?.remove_social_from_pending_deactivation}
                      onChange={() => handleCascadeFieldChange('remove_social_from_pending_deactivation', !data.remove_social_from_pending_deactivation)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="padding-10">Leaderboards: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_leaderboards"
                      label="Enable Leaderboards"
                      checked={data?.uses_leaderboards}
                      onChange={() => handleCascadeFieldChange('uses_leaderboards', !data.uses_leaderboards)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_view_leaderboards_not_logged_into"
                      label="Allow participants to view leaderboards of any program he is not currently logged into"
                      checked={data?.allow_view_leaderboards_not_logged_into}
                      onChange={() => handleCascadeFieldChange('allow_view_leaderboards_not_logged_into', !data.allow_view_leaderboards_not_logged_into)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="share_siblings_leader_board"
                      label="Share parent/sibling leaderboards"
                      checked={data?.share_siblings_leader_board}
                      onChange={() => {
                        data.share_siblings_leader_board =
                          !data.share_siblings_leader_board;
                      }}
                    />
                  </div>
                </Col>
              </Row>
              {!data.parent_id && (
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="use_one_leaderboard"
                      label="Share leaderboards"
                      checked={data?.use_one_leaderboard}
                      onChange={() => handleCascadeFieldChange('use_one_leaderboard', !data.use_one_leaderboard)}
                    />
                  </div>
                </Col>
              </Row>)}

              <Row>
                <Col>
                  <h4 className="padding-10">Peer to Peer: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_peer2peer"
                      checked={data?.uses_peer2peer}
                      label="Enable Peer to Peer"
                      onChange={() => handleCascadeFieldChange('uses_peer2peer', !data.uses_peer2peer)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_award_peers_not_logged_into"
                      label="Allow participants to award peers in any program he is not currently logged into"
                      checked={data?.allow_award_peers_not_logged_into}
                      onChange={() => handleCascadeFieldChange('allow_award_peers_not_logged_into', !data.allow_award_peers_not_logged_into)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_search_peers_not_logged_into"
                      label="Allow participants to search for peers in any program he is not currently logged into"
                      checked={data?.allow_search_peers_not_logged_into}
                      onChange={() => handleCascadeFieldChange('allow_search_peers_not_logged_into', !data.allow_search_peers_not_logged_into)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_hierarchy_peer2peer"
                      label="Use hierarchy peer 2 peer"
                      checked={data?.uses_hierarchy_peer2peer}
                      onChange={() => handleCascadeFieldChange('uses_hierarchy_peer2peer', !data.uses_hierarchy_peer2peer)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="share_siblings_peer2peer"
                      label="Share sibling's peer to peer"
                      checked={data?.share_siblings_peer2peer}
                      onChange={() => {
                        data.share_siblings_peer2peer =
                          !data.share_siblings_peer2peer;
                      }}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <h4 className="padding-10">Goals: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_goal_tracker"
                      label="Enable goal tracker"
                      checked={data?.uses_goal_tracker}
                      onChange={() => handleCascadeFieldChange('uses_goal_tracker', !data.uses_goal_tracker)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="padding-10">Credit Card Settings: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_credit_card_payments"
                      label="Allow credit card payments"
                      checked={data?.allow_credit_card_payments}
                      onChange={() => {
                        const newValue = !data.allow_credit_card_payments;
                        data.allow_credit_card_payments = newValue;
                        setFormValues({ allow_credit_card_payments: newValue });
                        toggleHierarchy();
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="padding-10">Other: </h4>
                </Col>
              </Row>
              <Row>
                <Col sm="6" md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_units"
                      label="Uses units"
                      checked={data?.uses_units}
                      onChange={() => handleCascadeFieldChange('uses_units', !data.uses_units)}
                    />
                  </div>
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_multiple_participants_per_unit"
                      label="Allow multiple participants per unit"
                      checked={data?.allow_multiple_participants_per_unit}
                      onChange={() => handleCascadeFieldChange('allow_multiple_participants_per_unit', !data.allow_multiple_participants_per_unit)}
                    />
                  </div>
                </Col>
                <Col sm="6" md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="enable_how_are_you_feeling"
                      label="How are you feeling"
                      checked={data?.enable_how_are_you_feeling}
                      onChange={() => handleCascadeFieldChange('enable_how_are_you_feeling', !data.enable_how_are_you_feeling)}
                    />
                  </div>
                  <div className="form__form-group">
                    <CheckboxField
                      name="enable_referrals"
                      label="Referrals"
                      checked={data?.enable_referrals}
                      onChange={() => handleCascadeFieldChange('enable_referrals', !data.enable_referrals)}
                    />
                  </div>
                </Col>
                <Col sm="6" md="4" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_milestone_award"
                      label="Allow Milestone Awards"
                      checked={data?.allow_milestone_award}
                      onChange={() => handleCascadeFieldChange('allow_milestone_award', !data.allow_milestone_award)}
                    />
                  </div>
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_activation_awards"
                      label="Allow Activation Awards"
                      checked={data?.allow_activation_awards}
                      onChange={() => handleCascadeFieldChange('allow_activation_awards', !data.allow_activation_awards)}
                    />
                  </div>
                </Col>
                {/* <Col sm="6" md="4" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_award_new_participant"
                      label="Award new participant"
                      checked={data?.allow_award_new_participant}
                      onChange={() => {
                        data.allow_award_new_participant =
                          !data.allow_award_new_participant;
                      }}
                    />
                  </div>
                </Col> */}
                <Col sm="6" md="4" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_loginto_enterprise_version_simply"
                      label="Allow participant to log into the enterprise version of simply"
                      checked={data?.allow_loginto_enterprise_version_simply}
                      onChange={() => handleCascadeFieldChange('allow_loginto_enterprise_version_simply', !data.allow_loginto_enterprise_version_simply)}
                    />
                  </div>
                </Col>
                <Col sm="6" md="4" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_manager_to_manage_program"
                      label="Allow Manager to manage Program"
                      checked={data?.allow_manager_to_manage_program}
                      onChange={() => handleCascadeFieldChange('allow_manager_to_manage_program', !data.allow_manager_to_manage_program)}
                    />
                  </div>
                </Col>
                <Col sm="6" md="4" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="hide_sign_up_form"
                      label="Hide Sign Up Form"
                      checked={data?.hide_sign_up_form}
                      onChange={() => handleCascadeFieldChange('hide_sign_up_form', !data.hide_sign_up_form)}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_third_party"
                      label="Third Party (HMI)"
                      checked={data?.allow_third_party}
                      onChange={() => {
                        data.allow_third_party = !data.allow_third_party;
                      }}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <label className="form__form-group-label">
                      Allow Manager to Invite/Award participants
                    </label>
                    <div className="d-flex flex-column">
                      <RadioButtonField
                        name="manager_invite"
                        radioValue="invite"
                        value={values.manager_invite}
                        label="Invite"
                        onChange={(val) => {
                          form.change("manager_invite", val);
                           const updatedValues = {
                            program_managers_can_invite_participants: true,
                            allow_award_new_participant: false,
                          };
                          data.program_managers_can_invite_participants = true;
                          data.allow_award_new_participant = false;
                          setFormValues(updatedValues); 
                          handleManagerInviteChange();
                        }}
                      />

                      <RadioButtonField
                        name="manager_invite"
                        radioValue="invite_award"
                        value={values.manager_invite}
                        label="Invite & Award"
                        onChange={(val) => {
                          form.change("manager_invite", val);
                           const updatedValues = {
                            program_managers_can_invite_participants: true,
                            allow_award_new_participant: true,
                          };
                          data.program_managers_can_invite_participants = true;
                          data.allow_award_new_participant = true;
                          setFormValues(updatedValues); 
                          handleManagerInviteChange();
                        }}
                      />

                      <RadioButtonField
                        name="manager_invite"
                        radioValue="hide"
                        value={values.manager_invite}
                        label="Hide"
                        onChange={(val) => {
                          form.change("manager_invite", val);
                           const updatedValues = {
                            program_managers_can_invite_participants: false,
                            allow_award_new_participant: false,
                          };
                          data.program_managers_can_invite_participants = false;
                          data.allow_award_new_participant = false;
                          setFormValues(updatedValues); 
                          handleManagerInviteChange();
                        }}
                      />
                    </div>
                  </div>
                </Col>
                <Col sm="6" md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_send_reward"
                      label="Allow Send Rewards on manager side"
                      checked={data?.allow_send_reward}
                      onChange={() => handleCascadeFieldChange('allow_send_reward', !data.allow_send_reward)}
                    />
                  </div>
                </Col>
                <Col sm="6" md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="resend_activation_link"
                      label="Enable Resend Activation Link"
                      checked={data?.resend_activation_link}
                      onChange={() => handleCascadeFieldChange('resend_activation_link', !data.resend_activation_link)}
                    />
                  </div>
                </Col>
                {data?.parent_id == null && (
                    <Col sm="6" md="6" lg="4" xl="4">
                        <div className="form__form-group">
                        <CheckboxField
                            name="enable_2fa"
                            label="Enable 2FA (disabling 2FA only works when program is in demo mode)"
                            checked={data?.enable_2fa}
                            onChange={() => handleCascadeFieldChange('enable_2fa', !data.enable_2fa)}
                        />
                        </div>
                    </Col>
                )}
                <Col sm="6" md="6" lg="4" xl="4">
                 <div className="d-flex">
                    <CheckboxField
                      name="add_referred_as_participant"
                      label="Add referred as Participant"
                      checked={data.add_referred_as_participant}
                      onChange={() => handleCascadeFieldChange('add_referred_as_participant', !data.add_referred_as_participant)}
                    />
                  </div>
                </Col>
                <Col sm="6" md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_save_to_hierarchy"
                      label="Allow Save to Hierarchy"
                      checked={data?.allow_save_to_hierarchy}
                      onChange={() => handleCascadeFieldChange('allow_save_to_hierarchy', !data.allow_save_to_hierarchy)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="padding-10">Entrata: </h4>
                </Col>
              </Row>
              <Row>
                <Col sm="6" md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_entrata_pending_approvals"
                      label="Enable Entrata Pending Approvals"
                      checked={data?.uses_entrata_pending_approvals}
                      onChange={() => {
                        data.uses_entrata_pending_approvals =
                          !data.uses_entrata_pending_approvals;
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </ModalBody>
          </form>
        )}
      </Form>
    </Modal>

    {/* update hierarchy modal */}
            <Modal
              className={`modal-event-hierarchy modal-md`}
              isOpen={isOpenHierarchy}
              toggle={toggleHierarchy}
            >
              <ModalHeader>
                <div>
                  Would you like to save this attribute across the entire program
                  hierarchy?
                </div>
              </ModalHeader>
              <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
                <Button
                  outline
                  className="btn btn-primary btn-sm"
                  onClick={onSubmitForm}
                  color="#ffffff"
                >
                  No, only save to this program
                </Button>
                <Button
                  outline
                  className="btn btn-primary btn-sm"
                  onClick={onSubmitHierarchy}
                  color="#ffffff"
                  style={{ float: "left" }}
                >
                  Yes, save to Hierarchy
                </Button>
                <Button
                  outline
                  color="primary"
                  className="btn btn-sm"
                  onClick={toggleHierarchy}
                  style={{ float: "right" }}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>

        {/*  update modal end */}
        {/* list hierarchy modal */}
        <Modal
          className={`modal-event-hierarchy-list modal-lg`}
          isOpen={isOpenHierarchyList}
          toggle={toggleHierarchyList}
        >
          <ModalHeader>
            <div>
              Please select the programs that you wish to update or add this
              attribute to
            </div>
          </ModalHeader>
          <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
            <Form onSubmit={onSubmitHierarchyList}>
              {({ handleSubmit, form, submitting, pristine, values }) => (
                <>
                  <form className="form" onSubmit={handleSubmit}>
                    <div style={{ padding: "10px" }}>
                      <Button
                        outline
                        className="btn btn-primary btn-sm"
                        color="#ffffff"
                      >
                        Save
                      </Button>
                    </div>

                    <Table
                      pagination={false}
                      rowKey="id"
                      columns={columnsHierarchyList}
                      dataSource={hierarchyListData}
                    />
                  </form>
                </>
              )}
            </Form>
          </ModalBody>
        </Modal>
        {/* list hierarchy modal end */}

        {/* updated result hierarchy modal */}
        <Modal
          className={`modal-event-hierarchy-list modal-lg`}
          isOpen={isOpenHierarchyResult}
          toggle={toggleHierarchyResult}
        >
          <ModalHeader>
            <div></div>
          </ModalHeader>
          <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
            <Table
              pagination={false}
              rowKey="id"
              columns={columnsHierarchyResult}
              dataSource={hierarchyListDataResult}
            />
          </ModalBody>
        </Modal>
        {/* updated result hierarchy modal end */}
        {/* hierarchy threshold review modal */}
        {showHierarchyThresholdModal && (
        <HierarchyThresholdModal
            organizationId={data.organization_id}
            programId={data.id}
            onClose={() => setShowHierarchyThresholdModal(false)}
        />
        )}
        {/* hierarchy threshold review modal end */}
        <HierarchySaveModal
          isOpen={isCascadeConfirmOpen}
          toggle={() => setCascadeConfirmOpen(false)}
          organizationId={data.organization_id}
          programId={data.id}
          settingsGroup="engagement"
          fields={activeCascadeField ? { [activeCascadeField.name]: activeCascadeField.value } : {}}
          dispatch={dispatch}
          onSuccess={() => {
            dispatch(getProgramAction(data.organization_id, data.id));
            setActiveCascadeField(null);
          }}
        />
    </>
  );
};

EngagementModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  data: Object.isRequired,
};

export default withRouter(
  connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    data: state.program,
  }))(EngagementModal)
);
